import React from "react";

import { useSetRecoilState } from "recoil";
import { modalState } from "lib/store/common";

import {
  Modal,
  ModalImage,
  TermsOfUse as TermsOfUseText,
} from "@atsent/components";

export type TermsOfUseProps = {
  cx?: string;
};

export const TermsOfUse: React.FC<TermsOfUseProps> = ({ cx = "" }) => {
  const setModal = useSetRecoilState(modalState);
  return (
    <Modal
      cx={`SignUpModal ${cx}`}
      close={() => setModal((_) => ({ ..._, term: false }))}
      title={"atsent"}
    >
      <ModalImage text={"이용약관"} />
      <TermsOfUseText />
    </Modal>
  );
};
